module.exports = __webpack_public_path__ + "img/noResultOne.5037df71.png";